import { ChangeEvent, FC, useState, useEffect } from 'react';
import styles from './index.module.scss';
import { SearchCheckboxItem } from '../../SearchCheckboxList';
import { AccordionList } from './AccordionList';
import { AccordionListItem } from './AccordionListItem';

/**
 * Props
 * @param title タイトルテキスト
 * @param list 表示用配列
 */
interface Props {
  title: string;
  list: {
    id: string;
    name: string;
    value: string;
    isChecked: boolean;
    jobCount: number;
  }[];
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

/**
 * 検索サイドバー・詳細条件
 */
export const SearchDetailCondition: FC<Props> = ({ title, list, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const isChecked = list.some((item) => item.isChecked);
    if (isChecked) {
      setIsOpen(true);
    }
    // 初期表示時のみ実行する
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AccordionList>
      <AccordionListItem
        heading={title}
        key={title}
        selected={list.some((item) => item.isChecked)}
        isOpen={isOpen}
      >
        {list.map((item, index) => (
          <li
            className={styles.searchCondition__accordion__list}
            key={item.id + index}
          >
            <SearchCheckboxItem
              title={item.name}
              value={item.value}
              isChecked={list[index].isChecked}
              count={list[index].jobCount}
              onChange={onChange}
            />
          </li>
        ))}
      </AccordionListItem>
    </AccordionList>
  );
};
